module.exports = __webpack_public_path__ + "static/media/language.bc27a861.svg";